import { getFunctions, httpsCallable } from "firebase/functions";
import "../firebase";

export async function callPlaqueFunction(name, data = {}) {
  const result = await httpsCallable(getFunctions(undefined, "us-central1"), name)(data);
  return result.data;
}

export const ensureVehicleBuildId = (username, carId) =>
  callPlaqueFunction("ensureVehicleBuildId", { username, carId: String(carId) });
export const loadVehiclePlaque = (username, carId) =>
  callPlaqueFunction("loadVehiclePlaque", { username, carId: String(carId) });
export const saveVehiclePlaque = (data) => callPlaqueFunction("saveVehiclePlaque", data);
